
import { Component, Vue, Prop } from 'vue-property-decorator'
import type { SharePopupParams } from './index.vue'
import Price from '@/components/Price/index.vue'
import dayjs from 'dayjs'
import { handleFill } from '@/utils/util'

@Component({
  components: { Price }
})
class ActivityPoster extends Vue {
  @Prop({ required: true }) data!: SharePopupParams
  handleFill = handleFill

  /** 最多展示1张图片，没有图片时使用默认图 */
  get displayImages (): string[] {
    // 默认使用 default-img1.png
    const defaultImg = require('@/assets/images/wordChain/default-img1.png')
    if (!this.data.images || this.data.images.length === 0) {
      return [defaultImg]
    }
    return this.data.images.slice(0, 1)
  }

  get createTimeText () {
    const { createTime } = this.data
    return createTime ? dayjs(createTime).format("YYYY.MM.DD发起") : ''
  }

  getPriceVal(index) {
    const { price } = this.data
    return price.split('-')[index]
  }
}

export default ActivityPoster
